import htmlComponent from "htmlcomponent";

export default function (dom, opts) {
    let options = {

        hideCls: 'remove-news-item',
        itemSel: '[data-values]',
        singleFilterSel: '.news-filter__single',
        singleFilterInputSel: '.news-filter__input',

        ...opts
    };

    const filterSingle = Array.from(dom.querySelectorAll('.news-filter__single'));
    const newsItem = Array.from(dom.querySelectorAll(options.itemSel));
    const noNewsFound = dom.querySelector('.news__nothing-found');

    const singleElement = Array.from(dom.querySelectorAll('.news-filter__single'));

    let filterValue = "";

    function init() {
        filterRetailer();
    }

    function registerPath() {
        // Save current location for the news detail back link.
        return localStorage.setItem('last-filter', window.location.href)
    }

    function filterRetailer() {
        filterSingle.forEach( (filter, index) => {
            filter.addEventListener('click', () => {
                applyFilter(filter.querySelector(options.singleFilterInputSel).value)


                if(index === 0) {
                    // clear hash on first item ("All")
                    history.pushState("", document.title, window.location.pathname
                        + window.location.search);

                    // Keep the back link on the current list page without hash.
                    registerPath();
                }

                if (index !== 0) {
                    // set current active filter as hash in url
                    window.location.hash = `cat=${filter.querySelector(options.singleFilterInputSel).value}`;
                    registerPath();
                }
            })

            // remove foreign characters
            let decodeUrl = decodeURIComponent(window.location.hash).replace(/\s/g, ' ')
            // remove hash from url
            let replaceHash = decodeUrl.replace("#cat=", '')
            // if url's hash and filter value match activate filter
            if (filter.querySelector(options.singleFilterInputSel) !== null) {
                if (replaceHash === filter.querySelector(options.singleFilterInputSel).value) {
                    applyFilter(filter.querySelector(options.singleFilterInputSel).value)

                    filter.classList.add("active");

                    /* also show corresponding parent if filter is subfilter */
                    if (filter.parentElement.getAttribute('data-subfilter')) {
                        filter.parentElement.classList.add("show");
                        document.querySelector('[data-filter="'+filter.parentElement.getAttribute('data-subfilter')+'"]').classList.add("active");
                    }

                }
            }


        });
    }

    function applyFilter(value) {
        let delay = 0;
        filterValue = value;
        newsItem.forEach( filter => {
            // create array with filterable values - data-value
            const values = filter.dataset.values.split(/,\s*/);
            // search for current filter value
            const active = filterValue ? values.includes(filterValue) : true;
            filter.classList.add(options.hideCls);

            if (active) {
                setTimeout(()=> {
                    filter.style.animationDelay = `${delay}ms`;
                    filter.classList.remove(options.hideCls);
                    delay += 100;
                    noNewsFound.classList.remove('news__nothing-found--show');
                }, 0)
            } else {
                noNewsFound.classList.add('news__nothing-found--show');
            }

        })
    }

    init()

}
